module.exports = __webpack_public_path__ + "img/seq2.e378b3ee.png";